var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "premiere-pro_5968525 (1)",
    clipPath: "url(#clip0_1588_11568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Surfaces_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video_Audio_Surface"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_no_shadow_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9365 1.12503H74.0615C82.8741 1.12503 89.999 8.24997 89.999 17.0625V72.9376C89.999 81.7502 82.8741 88.8751 74.0615 88.8751H15.9365C7.12396 88.8751 -0.000976562 81.75 -0.000976562 72.9376V17.0625C-0.000976562 8.24997 7.12396 1.12503 15.9365 1.12503Z",
    fill: "#00005B"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Outlined_Mnemonics_Logos_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pr"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.3738 23.4376C36.4486 23.4376 38.9986 23.8125 41.0986 24.6C44.6251 25.9224 47.5252 28.3597 48.8613 31.9501C49.4238 33.5251 49.7238 35.1376 49.7238 36.8251C49.7238 42.3542 46.8066 47.4048 41.4363 49.3877C38.8863 50.3251 36.0739 50.6626 32.9988 50.6626C32.0989 50.6626 31.4988 50.6626 31.1238 50.6252C30.7489 50.5877 30.2239 50.5877 29.5114 50.5877V62.6253C29.5489 62.8877 29.3615 63.1127 29.0989 63.1503C29.0614 63.1503 29.0238 63.1503 28.9489 63.1503H21.824C21.524 63.1503 21.374 63.0004 21.374 62.6629V24.075C21.374 23.8125 21.4865 23.6624 21.749 23.6624C22.3865 23.6624 22.9864 23.6624 23.849 23.625L33.3738 23.4376ZM29.5487 30.9V43.5001C30.0737 43.5375 30.5612 43.5751 31.0112 43.5751H32.9987C34.4611 43.5751 35.9236 43.3501 37.311 42.9001C39.9965 42.0292 41.5486 39.8442 41.5486 37.0503C41.5486 34.7102 40.3117 32.4288 38.0612 31.5752C36.6738 31.0127 35.1737 30.7877 33.6362 30.8251C32.6612 30.8251 31.7986 30.8251 31.0862 30.8626C30.3362 30.825 29.8111 30.8626 29.5487 30.9Z",
    fill: "#9999FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M54.9737 33.0751H61.5362C61.9111 33.0751 62.2112 33.3375 62.3237 33.675C62.4361 33.975 62.5112 34.2749 62.5486 34.6124C62.6237 34.9873 62.6986 35.3999 62.7362 35.7748C62.7736 36.1874 62.8113 36.6374 62.8113 37.1248C63.9362 35.8123 65.2862 34.7247 66.8237 33.8998C68.5488 32.9248 70.5363 32.4374 72.5238 32.4374C72.7862 32.3999 73.0112 32.5873 73.0488 32.8499V32.9998V40.3123C73.0488 40.6124 72.8613 40.7249 72.4489 40.7249C71.099 40.6874 69.7114 40.7999 68.3989 41.0998C67.3113 41.3248 66.2614 41.6623 65.2488 42.1123C64.5363 42.4498 63.8613 42.8998 63.3363 43.4997V62.6247C63.3363 62.9997 63.1864 63.1498 62.8489 63.1498H55.4613C55.1613 63.1872 54.8988 62.9998 54.8614 62.6998C54.8614 62.6623 54.8614 62.5873 54.8614 62.5498V41.7748C54.8614 40.8748 54.8614 39.9372 54.824 38.9624C54.7865 37.9873 54.7865 37.0123 54.7489 36.0374C54.7489 35.1749 54.6738 34.35 54.599 33.4874C54.5615 33.2999 54.674 33.1125 54.8614 33.0749C54.8612 33.0375 54.9361 33.0375 54.9737 33.0751Z",
    fill: "#9999FF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1588_11568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white",
    transform: "translate(-0.000976562 3.05176e-05)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremier);
export default __webpack_public_path__ + "static/media/premier.d881224ab60b0fac46958bf2f06292a0.svg";
export { ForwardRef as ReactComponent };